import React from "react";
import { Link } from "gatsby";
import Logo from "../../images/logo.svg";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-partners block">
          <h3>Our Partners</h3>
          <div className="partner-logos">
            {/* Add partner logos here */}
          </div>
          <Link to="/become-our-partner" className="button">Become our partner</Link>
        </div>
      <div className="footer-main">
        <div className="footer-links">
          <h3>Explore</h3>
          <ul>
            <li><Link to="/category">Countries</Link></li>
            <li><Link to="/tag">Activities</Link></li>
            <li><Link to="/features">Features</Link></li>
            <li><Link to="/types">Types</Link></li>
          </ul>
        </div>

        <div className="footer-links">
          <h3>Discover</h3>
          <ul>
            <li><Link to="/">Best places</Link></li>
            <li><Link to="/events/">Unique events</Link></li>
            <li><Link to="/stories/">Real stories</Link></li>
          </ul>
        </div>
        
                <div className="footer-links footer-logo">
                  <h3>Contact us</h3>
          <ul>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/contact-us">Contact</Link></li>
          </ul>
          <Link to="/">
            <img src={Logo} alt="Logo" />
          </Link>
        </div>
      </div>
      <div className="footer-copyright">
        <p>&copy; {new Date().getFullYear()} Map4Nomads.com and LeCecil s.r.o.. All Rights Reserved. <br/>
          <Link to="/privacy-policy">Privacy Policy</Link> <Link to="/cookie-policy-eu">Cookie Policy</Link></p>
      </div>
    </footer>
  );
};

export default Footer;
